<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import AddEdit from "./AddEdit.vue";
import StrIsoDuzelticiFaaliyet from "@/models/StrIsoDuzelticiFaaliyet"; import Swal from "sweetalert2";
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import formcheckbox from "@/router/views/FormComponet/formcheckbox.vue";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiAnaBirim.vue";
export default {
  mixins: [Api, Sabit, StrIsoDuzelticiFaaliyet],
  page: {
    title: "İyileştirmeler",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    AddEdit, formcombobox, formcheckbox,BirimSecimi
  },
  data() {
    return {
      title: "Düzeltici Faaliyetin Tamamlanması",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "Kalite Yönetim Sistemi (ISO 9001) Çalışmaları",
        },
        {
          text: "Düzeltici Faaliyetin Tamamlanması",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      Filter: {
        Acanbirimid: null,
        Tespitsekliid: null,
        Acilisonay: null,
        Kapanisonay: null
      },
      DetayId: null,
      OPersonelid: null,
      Birimler: [],
      BirimRoleKontrol: false
    };
  },

  methods: {
    Get() {
      if (this.OPersonelid) { this.TableGet() }

    },
    TableGet() { 
      if (this.Filter.Acanbirimid != null) {
      var Filter = "&Desc=No&Acilisonay=true"
      if (this.Filter.Acanbirimid != null) { Filter += "&Acanbirimid=" + this.Filter.Acanbirimid }
      if (this.Filter.Tespitsekliid != null) { Filter += "&Tespitsekliid=" + this.Filter.Tespitsekliid }
      if (this.Filter.Kapanisonay == true) { Filter += "&Kapanisonay=" + this.Filter.Kapanisonay }

      this.ActionsFilterGet({ Service: "StrIsoDuzelticiFaaliyet", Page: this.Page, Filter: Filter }).then((res) => {

        
        
          var Data = res.Data;
          for (let index = 0; index < Data.length; index++) {
            const element = Data[index]; 
            element.Kanit = this.TryParseJson(element.Kanit)
          } 
          this.TableData = Data;
           
        this.Page.PageDataSize = res.TotalCount;
      });
    }
    },
    TryParseJson(param) {
      try {
        if (typeof param === "string") {
          return JSON.parse(param);
        }
        if (typeof param === "object" && param !== null) {
          return param;
        }
        return [];
      } catch (e) {
        return [];
      }
    },
    Kaydet(Data) {
      Swal.fire({
        title: "İşlemi Kaydet ",
        text: "Seçtiğiniz kayıt güncellenecektir",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      }).then((result) => {
        if (result.value) {
          Data.Kanit = JSON.stringify(Data.Kanit)
          this.Update("StrIsoDuzelticiFaaliyet", Data)
        }
      });

    },
    BirimOnay(Data, durum) {
      Swal.fire({
        title: "Onay " + (durum == false ? 'İptal' : ''),
        text: "Seçtiğiniz Faaliyetin onay durumu değiştiriliecek.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      }).then((result) => {
        if (result.value) {
          if (durum == true) { Data.Onaylayanid = this.OPersonelid } else { Data.Onaylayanid = null }
          Data.Kanit = JSON.stringify(Data.Kanit)
          this.Update("StrIsoDuzelticiFaaliyet", Data, "Onay durumu değiştirildi.")
        }
      });

    },
    
    FileUpload(event, index) {
      var file = event.target.files[0];
      let x = file.name;
      var uzanti = x.substr(
        x.lastIndexOf(".") + 1,
        x.length - x.lastIndexOf(".")
      );
      if (
        uzanti == "png" ||
        uzanti == "jpeg" ||
        uzanti == "jpg" ||
        uzanti == "doc" ||
        uzanti == "xml" ||
        uzanti == "pdf" ||
        uzanti == "xlsx"
      ) {
        let formData = new FormData();
        formData.append("file", file);
        this.ActionsPost({
          Service: "GenericFileUpDownload/UploadFile?pathUrl=Str",
          Data: formData,
        }).then((res) => {
          if (res.Succeeded == true) {

            this.TableData[index].Kanit.push({
              'Tarih': this.Tarih,
              'Tip': 'File',
              'Kanit': res.Data.filename
            })
            this.$toast.success(this.$t("ToasMessage.FilePozitif"));
          } else {
            this.$toast.error(this.$t("ToasMessage.FileNegatif"));
          }
        });
      } else {
        this.$toast.error(this.$t("ToasMessage.FileNegatifUzanti"));
      }
    },
    openFileInput(index2) {
      const el = this.$refs.file[index2]    
      if (el) el.click()
    },
  
  isLink(text) {
    const urlPattern = /^(https?:\/\/|www\.)[^\s]+$/i;
    return urlPattern.test(text);
  },
  
    MuneRolesControl() {  
      let YetkiSorgu = this.UserRolles.filter((item) =>
        item.includes("SuperAdmin") || item.includes("StrAdmin") || item.includes("StrIsoBirimYetkili")
      );
      if (YetkiSorgu.length != 0) this.BirimRoleKontrol = true; 
    },

  },
  async created() {

    this.MuneRolesControl();
    var Page = {
      PageNumber: "1",
      PageSize: "1"
    }
    let Filter = "&Eposta=" + this.UserEMail;
    var res = await this.ActionsFilterGet({
      Service: "OPersonel",
      Page: Page,
      Filter: Filter,
    })
    this.OPersonelid = res.Data[0].Id;
    this.TableGet()

     Page = {
      PageNumber: "1",
      PageSize: "9999"
    }
    this.ActionsGet({ "Service": "OBirim", "Page": Page }).then((res) => { 
      for (var i = 0; i < res.Data.length; i++) {
        this.Birimler.push({ Id: res.Data[i].Id, Value: res.Data[i].BirimAdi })
      }
    });
  }
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">



                <formcombobox class="col-md-3" :FormDataType="FormDataType.Tespitsekliid" :Value="Filter.Tespitsekliid"
                  :v="$v.Filter.Tespitsekliid" @input="Filter.Tespitsekliid = $event" />
                <formcombobox v-if="0" class="col-md-3" :FormDataType="FormDataType.Acanbirimid" :Value="Filter.Acanbirimid"
                  :v="$v.Filter.Acanbirimid" @input="Filter.Acanbirimid = $event" />

                   
              <BirimSecimi class="col-md-3"
                    :title="FormDataType.Acanbirimid.FieldTitle"
                    :sutun="'0'" 
                    :title_class="'mb-3'"
                    :selected="Filter.Acanbirimid" 
                    :v="$v.Filter.Acanbirimid"
                    :YetkiKontrol="1"
                    :multiple="false"
                    :BirimTipId="null"
                    @Secilmis_Idler="Filter.Acanbirimid=$event"
                  />


                <formcheckbox class="col-md-1"
                  :FormDataType='{ FieldName: "Kapanisonay", Field: "checkbox", FieldTitle: "Kapanış Onay" }'
                  :Value="Filter.Kapanisonay" :v="$v.Filter.Kapanisonay" @input="Filter.Kapanisonay = $event" />

                <div class="col-sm-2 ">
                  <button type="button" class="btn btn-secondary btn-rounded mb-2 me-2 mt-4" @click="TableGet()"> <i
                      class="mdi mdi-text-search me-1"></i>Filtreleme</button>
                </div>



              </div>

              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>DF No</th>
                      <th>DF Açılış Tarihi</th>
                      <th>DF Açan Kişi</th>
                      <th>DF Açan Kişi Birim</th>
                      <th>DF Açılan Birim</th>
                      <th>Tespit Şekli</th>
                      <th>Uygunsuzluk Tanımı</th> 
                      <th>Yapılacak Düzeltici Faaliyet</th>
                      <th>Öngörülen Bitirme Tarihi</th>
                      <th v-if="0">Kanıt</th>
                      <th>Bitirme Tarihi</th>
                      <th>DF Onaylayan Kişi</th>
                      <th>Kapanış Onayı</th>
                      <th>İşlemler</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(Data, index2) in TableData" :key="Data.Id">
                      <th scope="row" class="text-dark">{{ Data.No }}</th>
                      <td>{{ Data.Acilistarih | formatDateTable }}</td>
                      <td>{{ Data.Acan }}</td>
                      <td>{{ Data.Acankisibirim }}</td>
                      <td>{{ Data.Acanbirim }}</td>
                      <td>{{ Data.Tespitsekli }}</td>
                      <td>{{ Data.Uyumsuzluktanim }}</td> 
<td v-if="BirimRoleKontrol"> <textarea v-model="Data.Yapiacakduzelticifaaliyet" class="form-control" style="min-width: 200px;"></textarea> </td>
<td v-else> {{  Data.Yapiacakduzelticifaaliyet  }}</td>
<td v-if="BirimRoleKontrol"><b-form-input v-model="Data.Ongorulenbitirmetarih" type="date"></b-form-input></td>
<td v-else>{{ Data.Ongorulenbitirmetarih | formatDateTable  }}</td>
                      
                        <td  v-if="0"> 

                                         <div class="row" v-if="Data.Durum != 2 && Data.Durum != 4 ? true : false">
                          <div class="col-md-6"> <input type="file" ref="file" style="display:none"
                              @change="FileUpload($event, index2)" accept=".pdf, .doc, .png" />

                            <i class="fas fa-upload" style="cursor:pointer; font-size:20px;"
                              @click="openFileInput(index2)">
                            </i>
                          </div>
                          <div class="col-md-6">
                            <i v-if="Data.Durum != 2 && Data.Durum != 4 ? true : false" class="fas fa-plus"
                              @click="Data.Kanit.push({ 'Kanit': null, 'Tarih': Tarih, 'Tip': 'Text' });"></i>
                          </div>
                        </div>


                        <div class="row" v-for="(value, index) in Data.Kanit" :key="index">
                          <textarea v-model="value.Kanit" class="form-control" v-if="value.Tip == 'Text' && Data.Durum != 2 && Data.Durum != 4 ? true : false"  ></textarea>
                          <span  v-if="value.Tip == 'Text' && ( Data.Durum == 2 || Data.Durum == 4 )" > 
                            <a  v-if="isLink(value.Kanit)" :href="value.Kanit"  target="_blank" class="text-primary text-decoration-underline">
        {{ value.Kanit }} </a> 
<span v-else>{{ value.Kanit }}</span> 

                          </span>
                          <a v-if="value.Tip == 'File'" :href="$config.FILES_URL + 'str/' + value.Kanit" target="_blanl">
                            <i class="fas fa-eye" v-tooltip="'Dosya Görüntüle'"></i> {{ value.Kanit }}</a>
                        </div>


                         

                      </td>
                      <td v-if="0">
                        <b-form-input v-model="Data.Bitirmetarih" type="date"></b-form-input>
                      </td>
                      <td>{{ Data.Bitirmetarih | formatDateTable  }}</td>
                      
                      <td v-if="BirimRoleKontrol">

 
                        <div class="action-is w-100 d-flex justify-content-center align-items-center">
                          <i class="fas fa-check" tooltip="Kapanış" @click="BirimOnay(Data, true)"
                            v-if="!Data.Onaylayan && Data.Bitirmetarih"></i>
                          <i class="fas fa-times" @click="BirimOnay(Data, false)" v-if="Data.Onaylayan"></i> {{
                          Data.Onaylayan }}
                        </div>

                      </td>
                      <td v-else>{{ Data.Onaylayan   }} </td>


                      <td>{{ Data.Kapanisonay == true ? 'X' : '' }} </td>
                      <td>

                        <div class="action-is w-100 d-flex justify-content-center align-items-center">
                          <i class="fas fa-save " tooltip="Kapanış" @click="Kaydet(Data)"></i>
                        </div>

                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage"
                  :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table"
                  @input="ChangePage(DefaultPage)"> </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="TableGet" :OPersonelid="OPersonelid" />


    </Layout>
  </Loader>
</template>
